import React from "react";
import AdminModulePage from "../../../components/Admin/ModulePage/AdminModulePage";

const UserManagement = () => {
    return <AdminModulePage moduleKey="user-management" />;
};

export default UserManagement;
